
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state:{
    logOrReg: 0, // 判断显示登陆弹窗还是注册弹窗1：密码登录 2：注册 3：验证码
    userTeamNav: 1,//我的团队 1：A级 2：B级
    userNav: 1,
    uuid:'',//用户标识
    headUserName:'',
    registerInput:{
      phone:'',//电话
    },
  },
   getters:{   //实时监听state值的变化(最新状态)
    isLoginShow(state) {  //方法名随意,主要是来承载变化的loginShow的值
      return state.loginShow
    },
  },
  mutations:{
    changeLoginValue(state,isChange) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
      state.loginShow = isChange;
    },
    changeUuid(state,isChange){ //用户标识
      state.uuid = isChange;
    },
    changeuserName(state,isChange){ //用户昵称或用户手机
      state.registerInput.phone = isChange;
    },
    logOrRegFun:function(state,payload){
    state.logOrReg = payload;
    },
    changeuserNav:function(state,isChange){ //课表跳转
      state.userNav = isChange;
    },
    changeRecord:function(state,isChange){
      state.record = isChange;
    },
    changeheadUserName:function(state,isChange){  //用户昵称或用户手机
      state.headUserName = isChange;
    },
}
})



//////////////////
// WEBPACK FOOTER
// ./store/store.js
// module id = null
// module chunks = 